<template>
<div class="searchContainer">
    <div class="searchContainerUp"></div>
    <div class="containerOne" style="position:relative;width:100%;height:820px;margin:0">
      <div style="width:1300px;margin:0 auto">
        <!-- 公共组建开始 -->
        <module-tit title="Search for" subTitle="搜索" titleStyle="width:500px;color:#fff" subTitleStyle="width:795px;"/>
        <!-- 公共组件结束 -->
        <el-form ref="searchForm" :model="searchForm" label-width="0">
          <el-form-item label="">
            <el-input v-model="searchForm.name" placeholder="请输入您要查询的关键字" style="width:85%;border-radius:none;float:left"></el-input>
            <el-button type="primary" icon="el-icon-search" style="width:15%;height:60px;font-size:26px;background:#272a36;border:none" @click="seatchResult">搜索</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="onSubmit">立即创建</el-button>
            <el-button>取消</el-button>
          </el-form-item> -->
        </el-form>


        <div class="clearBoth"></div>
        
      </div>
    </div>
    <!-- <footerComponent/> -->
</div>
</template>
<script>
// import headerComponent from '@/components/header'
// import footerComponent from '@/components/footer'
// 引入Vue Carousel组件  
// import { Carousel, Slide } from 'vue-carousel'; 
import moduleTit from './components/moduleTit/index.vue'
export default {
  name: 'App',
   components:{
    // headerComponent,
    // footerComponent,
    // Carousel,  
    // Slide
    moduleTit
  },
  mounted() {  
    this.$nextTick(()=>{
       this.initMap();  
       this.initMap2();
    })
   
  }, 
  data() {  
    return {  
      searchForm:{
        name:''
      }
    };  
  }, 

  methods:{
    seatchResult() {
      let _content = this.searchForm.name
      this.$router.push({ path: '/seatchResult',query: { question:_content} })
    },
    initMap() {  
      /* eslint-disable */
      var map = new BMap.Map("map"); // 创建Map实例  
      map.centerAndZoom(new BMap.Point(120.246316,36.316754), 14); // 初始化地图,设置中心点坐标和地图级别  
      map.addControl(new BMap.MapTypeControl()); //添加地图类型控件  
      map.setCurrentCity("城阳"); // 设置地图显示的城市 此项是必须设置的  
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放  
    },
    initMap2() {  
      /* eslint-disable */
      var map = new BMap.Map("map2"); // 创建Map实例  
      map.centerAndZoom(new BMap.Point(120.64077,36.954096), 14); // 初始化地图,设置中心点坐标和地图级别  
      map.addControl(new BMap.MapTypeControl()); //添加地图类型控件  
      map.setCurrentCity("城阳"); // 设置地图显示的城市 此项是必须设置的  
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放  
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-input__inner{
  height:60px;
  line-height: 60px;
}
.searchContainer {
  background:url('./images/searchBg.png') no-repeat center/cover padding-box content-box;
  position: relative;
}
.searchContainerUp {
  background: #272a36;
  opacity: 0.6;
  width:100%;
  height:100%;
  position: absolute;
}
</style>
